import React from 'react';
import { useTranslation } from 'react-i18next';
import { Book, Sparkles, Users, ClipboardPen } from 'lucide-react';
import { Card } from '../ui/card';
import { useUser } from '@clerk/clerk-react';

function Features() {
  const { user } = useUser();
  const { t } = useTranslation();

  const featuresList = [
    {
      icon: Sparkles,
      title: t('featuresPage.features.docChat.title'),
      description: t('featuresPage.features.docChat.description'),
    },
    {
      icon: Book,
      title: t('featuresPage.features.aiCourse.title'),
      description: t('featuresPage.features.aiCourse.description'),
    },
    {
      icon: Users,
      title: t('featuresPage.features.community.title'),
      description: t('featuresPage.features.community.description'),
    },
    {
      icon: ClipboardPen,
      title: t('featuresPage.features.practice.title'),
      description: t('featuresPage.features.practice.description'),
    },
  ];

  return (
    <div>
      <div className="w-full mx-auto flex">
        <div className="py-4 px-4 sm:px-6 lg:px-6 h-full grid grid-cols gap-4">
          {/* Intro Section */}
          <div className="py-4 text-center lg:text-left lg:max-w-sm">
            <h1
              className="text-4xl sm:text-3xl font-extrabold text-brand mb-2 "
              style={{
                fontFamily: 'Finger Paint, serif',
              }}>
              {t('featuresPage.intro.greeting', { userFirstName: user?.firstName })}
            </h1>
            <h2 className="text-xl sm:text-2xl font-bold text-foreground/90 mb-2">
              {t('featuresPage.intro.heading')}
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t('featuresPage.intro.description')}
            </p>
          </div>

          {/* Features Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 flex-1 pt-2 cursor-pointer">
            {featuresList.map((feature, index) => (
              <Card
                key={index}
                className="p-4 bg-muted/40 shadow hover:shadow-md transition-all duration-200 hover:-translate-y-1">
                <div className="flex items-start gap-3">
                  <feature.icon className="w-8 h-8 text-brand shrink-0" />
                  <div>
                    <h3 className="text-base font-semibold text-foreground mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">{feature.description}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
